import dayjs from 'dayjs';
import 'dayjs/locale/es';
import qs from 'qs';
import {navigate} from '@reach/router';

dayjs.locale('es'); // usar la configuración regional española globalmente

export const formatDate = date => dayjs(date).format('MMMM DD, YYYY ');

// algolia

export const createURL = state => `?${qs.stringify(state)}`;

export const searchStateToUrl = (location, searchState) =>
  searchState ? `${location.pathname}${createURL(searchState)}` : '';

export const urlToSearchState = ({search}) => qs.parse(search.slice(1));

export const decodeRouteParam = value => {
  if (value == null || value === '') return value;
  try {
    return decodeURIComponent(value);
  } catch (e) {
    return value;
  }
};

export const getProjectPath = slug => {
  if (!slug) return '/proyectos';
  return `/proyectos/${encodeURIComponent(slug)}`;
};

export const buildProjectPreview = project => {
  if (!project) return null;
  const neighborhoodName =
    typeof project.neighborhood === 'string'
      ? project.neighborhood
      : project.neighborhood && project.neighborhood.name;
  const cityName =
    typeof project.city === 'string'
      ? project.city
      : project.city && project.city.name;
  return {
    id: project.id,
    name: project.name,
    image: project.image,
    title_slug: project.slug || project.title_slug,
    slug: project.slug || project.title_slug,
    stratus: project.stratus,
    min_last_price_in_thousands: project.price || project.min_last_price_in_thousands,
    min_area_by_type: project.area || project.min_area_by_type,
    general_use: project.general_use || project.generalUse,
    path_logo: project.path_logo || project.logo,
    neighborhood: neighborhoodName ? {name: neighborhoodName} : null,
    city: cityName ? {name: cityName} : null,
  };
};

export const goToProject = (slug, preview) =>
  navigate(getProjectPath(slug), {
    state: {projectPreview: buildProjectPreview(preview || {slug})},
  });
